<template>
  <div>
    <q-header elevated class="bg-white">
      <q-toolbar>
        <q-btn
          flat
          @click="toggleNav"
          color="accent"
          round
          dense
          icon="menu"
        ></q-btn>
        <q-toolbar-title>
          <!-- <q-img
            src="/statics/Logo.png"
            spinner-color="white"
            style="height: 40px; width: 100px"
            contain
          >
          </q-img> -->
          Flexi-comms
        </q-toolbar-title>
        <q-btn
          v-if="$route.path === '/triggerEvents'"
          flat
          dense
          :icon="showOverlaysByDefault ? 'mdi-eye' : 'mdi-eye-off'"
          :color="showOverlaysByDefault ? 'positive' : 'grey-7'"
          @click="toggleOverlays"
          label="Overlays"
        >
          <q-tooltip>
            {{ showOverlaysByDefault ? 'Overlays shown by default' : 'Overlays hidden by default' }}
            <br />
            Click to toggle
          </q-tooltip>
        </q-btn>
        <ConfigMenu />
      </q-toolbar>
    </q-header>

    <q-drawer
      :mini="miniState"
      v-model="drawer"
      show-if-above
      :width="200"
      :breakpoint="400"
    >
      <div class="bg-accent navBarLogo">
        <h3 v-if="!miniState" class="q-my-none">{{ siteData.name }}</h3>
        <h3 v-if="miniState" class="q-my-none">{{ siteData.prefix }}</h3>
      </div>
      <q-img class="bg-accent userInfoSection" style="height: 150px">
        <div class="absolute-bottom bg-transparent">
          <q-avatar
            v-if="!miniState"
            style="background-color: white"
            size="56px"
            class="q-mb-sm"
          >
            <img :src="currentUserData.profileImgUrl" />
          </q-avatar>
          <div class="row">
            <div v-if="!miniState" class="col-10">
              <div class="text-weight-bold">
                {{ currentUserData.name }}
              </div>
              <div
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100%;
                "
              >
                {{ currentUserData.email }}
              </div>
            </div>
            <div v-if="!miniState" class="col-2">
              <q-btn
                flat
                round
                color="negative"
                @click="$store.dispatch('auth/logout')"
                icon="mdi-logout"
              >
                <q-tooltip> Logout </q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>
      </q-img>
      <q-scroll-area
        style="height: calc(100% - 190px); border-right: 1px solid #ddd"
        class="bg-accent"
      >
        <q-list padding class="text-white">
          <div
            :key="`navLink_${index}`"
            v-for="(link, index) in displayedLinks"
          >
            <q-item
              v-if="
                !link.children &&
                !$route.params[link.hideOnPathID] &&
                (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              v-ripple
              :to="link.to"
              :exact="!link.disableExact"
              active-class="activePage"
            >
              <q-item-section avatar>
                <q-icon
                  :color="link.iconColor ? link.iconColor : 'accent2'"
                  :name="link.icon"
                ></q-icon>
              </q-item-section>
              <q-item-section> {{ link.text }} </q-item-section>
            </q-item>
            <q-expansion-item
              v-else-if="
                !$route.params[link.hideOnPathID] &&
                (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              :ref="link.text"
              :group="link.text"
              :icon="link.icon"
              :label="link.text"
              expand-icon-class="activePage"
            >
              <q-list padding class="text-white">
                <div
                  :key="`navLink_${childIndex}`"
                  v-for="(child, childIndex) in link.children"
                >
                  <q-item
                    v-if="!child.children"
                    v-ripple
                    :to="child.to"
                    :exact="!link.disableExact"
                    active-class="activePage"
                  >
                    <q-item-section avatar>
                      <q-icon
                        :color="child.iconColor ? child.iconColor : 'accent2'"
                        :name="child.icon"
                      ></q-icon>
                    </q-item-section>
                    <q-item-section> {{ child.text }} </q-item-section>
                  </q-item>
                </div>
              </q-list>
            </q-expansion-item>
          </div>

          <q-item
            v-if="currentUserData.impersonatingUser == true"
            v-ripple
            clickable
            @click="stopImpersonation"
          >
            <q-item-section avatar>
              <q-icon color="accent2" name="cancel"></q-icon>
            </q-item-section>

            <q-item-section> Stop Impersonation </q-item-section>
          </q-item>
        </q-list>
        <!-- <q-list padding class="text-white">
          <q-item
            v-for="(link, index) in displayedLinks"
            :key="`navLink_${index}`"
            v-ripple
            :to="link.to"
            exact
            active-class="activePage"
          >
            <q-item-section avatar>
              <q-icon
                :color="link.iconColor ? link.iconColor : 'accent2'"
                :name="link.icon"
              ></q-icon>
            </q-item-section>

            <q-item-section> {{ link.text }} </q-item-section>
          </q-item>
          <q-item
            v-if="currentUserData.impersonatingUser == true"
            v-ripple
            clickable
            @click="stopImpersonation"
          >
            <q-item-section avatar>
              <q-icon color="accent2" name="cancel"></q-icon>
            </q-item-section>

            <q-item-section> Stop Impersonation </q-item-section>
          </q-item>
        </q-list> -->
      </q-scroll-area>
    </q-drawer>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import ConfigMenu from "./generalComponents/ConfigMenu.vue";

  export default {
    components: {
      ConfigMenu
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteData: "settings/siteData",
        miniState: "settings/miniNavState",
        showOverlaysByDefault: "settings/showOverlaysByDefault"
      }),
    },
    data: () => ({
      drawer: false,

      // New Navigation
      // Navigation
      rolesAccess: {
        superAdmin: [
          "dashboard",
          "applications",
          "organizations",
          "ownerships",
          "deployments",
          "devices",
          "events",
          "triggerEvents",
          "eventLogs",
          "rock7",
          "users",
          "userProfile",
          "documentation",
          "map",
          "system",
          "deviceTypes",
          "deviceStatus",
        ],
        appAdmin: [
          "dashboard",
          "organizations",
          "ownerships",
          "deployments",
          "devices",
          "events",
          "triggerEvents",
          "userProfile",
          "documentation",
          "map",
          "system",
          "deviceTypes",
          "deviceStatus",
        ],
        orgAdmin: [
          "dashboard",
          "organizations",
          "deployments",
          "devices",
          "events",
          "triggerEvents",
          "userProfile",
          "map",
          "deviceStatus",
        ],
        orgUser: [
          "dashboard",
          "organizations",
          "deployments",
          "devices",
          "events",
          "triggerEvents",
          "userProfile",
          "map",
          "deviceStatus",
        ],
      },

      // Navigation
      links: [
        {
          to: "/",
          icon: "mdi-view-dashboard",
          text: "Dashboard",
          iconColor: "",
          name: "dashboard",
        },
        {
          to: "/organizations",
          icon: "mdi-domain",
          text: "Organizations",
          iconColor: "",
          name: "organizations",
        },

        {
          to: "/devices",
          icon: "mdi-cctv",
          text: "Devices",
          iconColor: "",
          name: "devices",
          children: [
            {
              to: "/ownerships",
              icon: "mdi-transit-connection",
              text: "Ownerships",
              iconColor: "",
              name: "ownerships",
            },
            {
              to: "/deployments",
              icon: "mdi-map-marker-path",
              text: "Deployments",
              iconColor: "",
              name: "deployments",
            },
            {
              to: "/devices",
              icon: "mdi-cctv",
              text: "Device Mgmt",
              iconColor: "",
              name: "devices",
            },
            {
              to: "/deviceTypes",
              icon: "mdi-grid",
              text: "Devices Types",
              iconColor: "",
              name: "deviceTypes",
            },
            // {
            //   to: "/deviceStatus",
            //   icon: "mdi-ab-testing",
            //   text: "Device Status",
            //   iconColor: "",
            //   name: "triggerEvents",
            // },
            {
              to: "/map",
              icon: "mdi-map",
              text: "Map",
              name: "map",
            },
          ],
        },

        {
          to: "/events",
          icon: "mdi-view-list",
          text: "Events",
          iconColor: "",
          name: "events",
          children: [
            {
              to: "/events",
              icon: "mdi-view-list",
              text: "All Events",
              iconColor: "",
              name: "events",
            },
            {
              to: "/triggerEvents",
              icon: "mdi-image",
              text: "Trigger Events",
              iconColor: "",
              name: "triggerEvents",
            },
            {
              to: "/rock7",
              icon: "mdi-view-list",
              text: "Rock7 Events",
              iconColor: "",
              name: "rock7",
            },
          ],
        },
        {
          to: "/system",
          icon: "mdi-cogs",
          text: "System",
          iconColor: "",
          name: "system",
          children: [
            {
              to: "/applications",
              icon: "mdi-application",
              text: "Applications",
              iconColor: "",
              name: "applications",
            },
            {
              to: "/users",
              icon: "mdi-account-group",
              text: "Users",
              name: "users",
            },
            {
              to: "/documentation",
              icon: "mdi-file-document",
              text: "Documentation",
              name: "documentation",
            },
            {
              to: "/eventLogs",
              icon: "mdi-view-list",
              text: "All Event Logs",
              iconColor: "",
              name: "eventLogs",
            },
          ],
        },

        {
          to: "/userProfile",
          icon: "mdi-account",
          text: "User Profile",
          name: "userProfile",
        },
      ],
      displayedLinks: [],
      generalLinks: [],
    }),
    watch: {
      currentUserData: function () {
        this.setLinks();
      },
    },
    beforeCreate() {},
    mounted() {
      if (typeof this.currentUserData.role != "undefined") {
        this.setLinks();
      }
    },
    methods: {
      toggleOverlays() {
        this.$store.dispatch('settings/toggleShowOverlaysByDefault');
        this.$q.notify({
          message: `Overlays ${this.showOverlaysByDefault ? 'disabled' : 'enabled'} by default`,
          color: this.showOverlaysByDefault ? 'warning' : 'positive',
          icon: this.showOverlaysByDefault ? 'mdi-eye-off' : 'mdi-eye',
          position: 'top',
          timeout: 2000
        });
      },
      setLinks() {
        this.displayedLinks = this.checkLinkPerms(this.links);
      },
      checkLinkPerms(links) {
        let newLinks = [];
        links.forEach((link) => {
          let newLink = JSON.parse(JSON.stringify(link));
          if (
            this.rolesAccess[this.currentUserData["role"]].includes(link.name)
          ) {
            if (newLink.idInPath) {
              let regex = /:.*/;
              let value = newLink.to.match(regex)[0].split("/")[0];

              newLink.to = newLink.to.replace(
                value,
                this.$route.params[value.substring(1)]
              );
            }

            if (link.children) {
              newLink.children = this.checkLinkPerms(link.children);
            }
            newLinks.push(newLink);
          }
        });
        return newLinks;
      },
      // setLinks() {
      //   // this.links = [];
      //   this.generalLinks.forEach((element) => {
      //     this.links.push(element);
      //   });

      //   if (this.currentUserData && this.currentUserData.role == "appAdmin") {
      //     this.links = this.applicationsLinks;
      //   }

      //   if (this.currentUserData && this.currentUserData.role == "orgAdmin") {
      //     this.links = this.organizationAdminLinks;
      //   }

      //   if (this.currentUserData && this.currentUserData.role == "orgUser") {
      //     this.links = this.organizationUserLinks;
      //   }

      //   if (this.currentUserData && this.currentUserData.role == "superAdmin") {
      //     this.links = this.adminLinks;
      //   }
      // },
      toggleNav() {
        if (this.$q.screen.lt.sm) {
          this.drawer = !this.drawer;
        } else {
          this.$store.dispatch("settings/togglMiniNav");
        }
      },
      stopImpersonation() {
        this.$store.dispatch("auth/impersonateStop");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .activePage {
    border-left: 3px solid $primary;
    background-image: linear-gradient(
      to left,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.2)
    );

    div {
      color: $primary;
    }

    i {
      color: $primary;
    }
  }
  .userInfoSection {
    border-right: 1px solid white;
    border-bottom: 1px solid $accent2;
  }
  .navBarLogo {
    height: 30pt;
    border-right: 1px solid white;
    h3 {
      color: white;
      text-align: center;
      font-size: 12pt;
      font-weight: bold;
    }
  }
</style>
